var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      width: "100%",
      display: "flex",
      "flex-direction": "column"
    },
    attrs: {
      id: "brandList"
    }
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticClass: "table-page-search-wrapper"
  }, [_c("a-form", {
    attrs: {
      layout: "inline"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getList.apply(null, arguments);
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("arrivalNotice.noticeTitle")
    }
  }, [_c("a-input", {
    attrs: {
      width: "200px",
      allowClear: true,
      placeholder: _vm.$t("publicuse.pleaseinput"),
      maxLength: 100
    },
    model: {
      value: _vm.queryParam.noticeTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "noticeTitle", $$v);
      },
      expression: "queryParam.noticeTitle"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("arrivalNotice.sellerName")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("publicuse.pleaseselect"),
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.sellerCode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "sellerCode", $$v);
      },
      expression: "queryParam.sellerCode"
    }
  }, _vm._l(_vm.sellerOptions, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.sellerCode
      }
    }, [_vm._v(" " + _vm._s(item.sellerName) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("span", {
    staticClass: "table-page-search-submitButtons",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.getList
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.inquire2")) + " ")])], 1)])], 1)], 1)], 1)]), _c("a-card", {
    staticStyle: {
      "margin-top": "24px",
      position: "relative",
      flex: "1 1 0%"
    },
    attrs: {
      id: "table",
      bordered: false
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c("a-button", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.handleAdd();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.new")))])], 1), _c("a-table", {
    attrs: {
      id: "sorttableclass",
      rowKey: "noticeid",
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.dataList,
      pagination: {
        showSizeChanger: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + _vm.listTotal;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.listTotal
      }
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a", {
          on: {
            click: function click($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.edit")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("publicuse.suerdelete"),
            "ok-text": _vm.$t("publicuse.yes"),
            "cancel-text": _vm.$t("publicuse.no")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_c("a", {
          attrs: {
            href: "javascript:;"
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.delete")))])])], 1);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };